// SPDX-License-Identifier: BUSL-1.1

/**
 * Toast notification helpers wrapping sonner.
 *
 */

import { toast } from 'sonner';

export function showSuccess(message: string) {
  toast.success(message);
}

export function showError(message: string, description?: string) {
  toast.error(message, { description });
}

export function showApiError(err: unknown) {
  const message = err instanceof Error ? err.message : 'An unexpected error occurred';
  toast.error('API Error', { description: message });
}
